import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class PropertyAPI {

  static ModelNo = 49;

  static list = (list, success, failure, logout) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const sorting = list.sorting;
    const body = { filter, page, perPage, sorting };
    fetch(Config.app.link + 'api/property/list', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure, logout))
      .catch(er => failure(er));
  };

  static count = (list, success, failure, logout) => {
    const filter = list.filter || list.filters;
    const page = list?.pagination?.currentPage || 1;
    const perPage = list?.pagination?.perPage || 1;
    const body = { filter: filter, page: page, perPage: perPage };

    fetch(Config.app.link + 'api/property/list/count', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure, logout))
      .catch(er => failure(er));
  };

  static get = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/property/' + id, new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure, logout))
      .catch(er => failure(er));
  };

  static saveProperty = (property, success, failure, logout) => {
    fetch(Config.app.link + 'api/property/add-edit', new Header('POST', property))
      .then(res => Const.ProcessAPI(res, success, failure, logout))
      .catch(er => failure(er));
  };

  static delete = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/property/delete/' + id, new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure, logout))
      .catch(er => failure(er));
  };

  static massUpdate = (list, selected, updates, success, failure) => {
    const filter = list.filters;
    const body = { filter: filter, selected, updates };

    fetch(Config.app.link + 'api/property/mass-update', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static getInnerList = (modelType, modelId, success, failure, logout) => {
    const filter = [{
      field: 'model', type: 'model', "condition": "equals",
      value: `${modelType}~${modelId}`
    }];
    const page = 1;
    const perPage = 10;
    fetch(Config.app.link + 'api/property/list', new Header('POST', { filter, page, perPage }))
      .then(res => Const.ProcessAPI(res, success, failure, logout))
      .catch(er => failure(er));
  };

  static getInnerProjectList = (modelId, success, failure, logout) => {
    const filter = [{
      field: 'project', type: 'select', condition: 'equals',
      value: Const.Opt + modelId + Const.Opt
    }];
    const page = 1;
    const perPage = 10000;
    fetch(Config.app.link + 'api/property/list', new Header('POST', { filter, page, perPage }))
      .then(res => Const.ProcessAPI(res, success, failure, logout))
      .catch(er => failure(er));
  };

  static getInnerContactList = (contact, success, failure, logout) => {
    fetch(Config.app.link + `api/contact/property/${contact}`, new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure, logout))
      .catch(er => failure(er));
  };

  static addContact = (property, contact, success, failure) => {
    fetch(Config.app.link + 'api/property/contact', new Header('POST', { property, contact }))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static getEncryptedKey = async (data) => {
    return await new Promise(resolve => {
      fetch(Config.app.link + 'api/micro-site/get-access', new Header('POST', data))
        .then(res => res.json().then(result => resolve(result)).catch(er => resolve(null)))
        .catch(er => resolve(null));
    });
  };

  static massDelete = (list, selected, success, failure) => {
    const filter = list.filters;
    const body = { filter: filter, selected };
    
    fetch(Config.app.link + 'api/property/mass-delete', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default PropertyAPI;